import { addresslookup } from './addresslookup';
import { codemarkup } from './codemarkup';

const frameexh = {
  initialize: function () {
    // Attach
    $(window).on('scroll', function () { frameexh.observe(); });

    // Attach
    $('.code-t2 .example').on('mouseover', function () { frameexh.show(this); });
    $('.code-t2 .example').on('mouseout', function () { frameexh.hide(this); });
    $('.code-t2 .get input').on('click', function () { frameexh.toggle(this); });
    $('.mnu a').on('click', function () { frameexh.scrollto(this); return false; });

    // Location dependent
    if (window.location.pathname.indexOf('themes') !== -1) {
      // Load
      this.lazyload();
    } else {
      // Lazy
      setTimeout(function () {
        frameexh.lazyload();
      }, 1000);
    }
  },
  lazyload: function () {
    // Loop, attach
    $('.code-t2').each(function () {
      // Get theme + color
      let thm = $(this).attr('data-theme');
      let col = $(this).attr('data-color');

      // Update iframe
      $(this).find('.example iframe').attr('src', '/add-to-calendar-button-theme-snippet?color=' + col + '&type=includebase&theme=' + thm);
    });
  },
  scrollto: function (f) {
    // Get modes
    let wm = $('.whitemode').offset().top - 70;
    let dm = $('.darkmode').offset().top - 70;
    // Theme
    let thm = $(f).attr('data-theme');

    if (thm == 'white') {
      window.scrollTo({ top: wm, behavior: 'smooth' });
    } else {
      window.scrollTo({ top: dm, behavior: 'smooth' });
    }
  },
  observe: function () {
    try {
      // Scroll top
      let t = $(document).scrollTop();

      // Get modes
      let wm = $('.whitemode').offset().top - 120;
      let dm = $('.darkmode').offset().top - 120;

      // Reset
      $(".mnu a").removeClass('selected');

      // Scroll position?
      if (t > dm) {
        $(".mnu .lnkdm").addClass('selected');
      } else {
        $(".mnu .lnkwm").addClass('selected');
      }
    } catch (e) {
      //nothing
    }
  },
  show: function (f) {
    // Show
    $(f).find('.mi1').addClass('show');
  },
  hide: function (f) {
    // Show
    $(f).find('.mi1').removeClass('show');
  },
  toggle: function (f) {
    // Get base
    let bas = $(f).closest('.code-t2');

    // Get theme
    let thm = $(f).attr('data-theme');
    let col = $(f).attr('data-color');

    // Get code snippet URL
    const urli = '/add-to-calendar-button-theme-snippet?color=' + col + '&type=nobase&theme=' + thm;

    // Toggle
    if (!$(bas).find('.exp').is(":visible")) {
      // Add
      $(bas).addClass('codeview');

      // Any contents?
      if (!$(bas).find('.codemarkup').length) {

        // Post
        $.ajax({
          type: "GET",
          url: urli,
          success: function (data) {
            // Encode
            let enc = frameexh.htmlencode(data);
            // Variable
            let html = "";

            // Add
            html += '<div class="sec">';
            html += "    <p>Add this code to your website</p>";
            html += '    <div class="tbs">';
            html += '        <div class="tab-set-t1">';
            html += '            <div class="rw">';
            html += '                <div class="nm">1</div>';
            html += '                <div class="ex">Copy and paste the "AddEvent theme CSS" to your existing stylesheet or link to the file in the <span class="markup-t1" style="line-height:22px;">&lt;head&gt;</span> section of your websites.</div>';
            html += "            </div>";
            html += '            <div class="rw">';
            html += '                <div class="nm">2</div>';
            html += '                <div class="ex">Copy and paste the "AddEvent JS file" to your existing javascript file or link to the file in the <span class="markup-t1" style="line-height:22px;">&lt;head&gt;</span> section of your websites.</div>';
            html += '            </div>';
            html += '            <div class="rw">';
            html += '                <div class="nm">3</div>';
            html += '                <div class="ex">Copy the "AddEvent button" code, paste it where you want it to appear on your website, and change the event details.</div>';
            html += '            </div>';
            html += '            <div class="rw">';
            html += '                <div class="nm">4</div>';
            html += '                <div class="ex">Add the domain where you use the button in the <a href="https://app.addevent.com/account/domains" title="" target="_blank">domains</a> section.</div>';
            html += '            </div>';
            html += '        </div>';
            html += '    </div>';
            html += '</div>';
            html += '<div class="codewrp">';
            html += '    <pre class="codemarkup"><code>' + enc + '</code></pre>';
            html += '</div>';

            // Update
            $(bas).find(".exp").html(html);

            // Show
            $(bas).find('.codemarkup').show();

            // Timed
            setTimeout(function () {
              // Get codemark element
              let elm = $(bas).find('.codemarkup');

              // Markup code
              frameexh.markup(elm);

              // Hide loading
              $(bas).find('.exp').addClass('done');
            }, 10);
          },
        });
      }
    } else {
      // Remove
      $(bas).removeClass("codeview");
    }
  },
  markup: function (elm) {
    // Get content
    let ctx = $(elm).html(), num = 0;

    // Get the line number count
    if (typeof ctx === 'string') {
      num = ctx.split(/\n/).length - 1;
    }

    // One line wraps
    if (num == "0" || num == "1") {
      // Add
      $(elm).addClass('inline');

      // Add auto avoid class to parent
      $(elm).parent(".exmctn").first().addClass('autoheight');

      // Set
      num = 1;
    }

    // Line number html
    let lhtml = "";

    // Loop
    for (let j = 0; j < num; j++) {
      // Collect
      lhtml += '<span class="num">' + (j + 1) + "</span>";
    }

    // Get content
    let str = ctx;

    // Replace tabs with spaces
    str = str.replace(/\t/g, "");

    // Values between ""
    str = str.replace(/"([^"]+)"/g, '"<span class="m5">$1</span>"');
    str = str.replace(/'([^']+)'/g, "'<span class=\"m5\">$1</span>'");

    // Rest
    //str = str.replace(/&lt;!-- AddEvent --&gt;/gi, '<span class="m1">&lt;!-- AddEvent --&gt;</span>');
    //str = str.replace(/&lt;!-- Button code --&gt;/gi, '<span class="m1">&lt;!-- Button code --&gt;</span>');
    str = str.replace(/&lt;html&gt;/gi, '&lt;<span class="m4">html</span>&gt;');
    str = str.replace(/&lt;\/html&gt;/gi, '&lt;/<span class="m4">html</span>&gt;');
    str = str.replace(/&lt;head&gt;/gi, '&lt;<span class="m4">head</span>&gt;');
    str = str.replace(/&lt;\/head&gt;/gi, '&lt;/<span class="m4">head</span>&gt;');
    str = str.replace(/&lt;style /gi, '&lt;<span class="m4">style</span> ');
    str = str.replace(/&lt;\/style&gt;/gi, '&lt;/<span class="m4">style</span>&gt;');
    str = str.replace(/&lt;body&gt;/gi, '&lt;<span class="m4">body</span>&gt;');
    str = str.replace(/&lt;\/body&gt;/gi, '&lt;/<span class="m4">body</span>&gt;');
    str = str.replace(/&lt;script/gi, '&lt;<span class="m4">script</span>');
    str = str.replace(/&lt;\/script&gt;/gi, '&lt;<span class="m4">/script</span>&gt;');
    str = str.replace(/&lt;div/gi, '&lt;<span class="m4">div</span>');
    str = str.replace(/&lt;\/div&gt;/gi, '&lt;/<span class="m4">div</span>&gt;');
    str = str.replace(/&lt;span/gi, '&lt;<span class="m4">span</span>');
    str = str.replace(/&lt;\/span&gt;/gi, '&lt;/<span class="m4">span</span>&gt;');
    str = str.replace(/type=/gi, '<span class="m2">type</span>=');
    str = str.replace(/src=/gi, '<span class="m2">src</span>=');
    str = str.replace(/ async/gi, '<span class="m2"> async</span>');
    str = str.replace(/ defer/gi, '<span class="m2"> defer</span>');
    str = str.replace(/\/\*/gi, '<span class="m9c">/*');
    str = str.replace(/\*\//gi, '*/</span>');
    str = str.replace(/function/gi, '<span class="m4">function</span>');
    str = str.replace(/&lt;!--/gi, '<span class="m9c">&lt;!--');
    str = str.replace(/--&gt;/gi, "--&gt;</span>");

    // Replace timezone
    str = str.replace(/America\/Los_Angeles/gi, '<div class="timezonechg" title="Change Timezone">America/Los_Angeles</div>');
    str = str.replace(
      /Europe\/Paris/gi,
      '<div class="timezonechg" title="Change Timezone">Europe/Paris</div>'
    );
    str = str.replace(/\$ curl/gi, '<span class="markup-t5">$ curl</span>');

    // Append frames
    $(elm).html('<div class="lines"><div class="bfnum">' + lhtml + '</div></div><div class="code"><div class="inn">' + str + '</div></div><div class="clr"></div>');

    // Show
    $(elm).show();

    // Attach
    $(elm)
      .find(".code .inn")
      .dblclick(function () {
        codemarkup.selectable(this);
        return false;
      });

    // Attach click
    $(elm)
      .find(".timezonechg")
      .each(function () {
        // Is set?
        if (!$(this).hasClass("isset")) {
          // Attach
          $(this)
            .off("click")
            .bind("click", function () {
              addresslookup.show(this);
              return false;
            });
          // Add
          $(this).addClass("isset");
        }
      });

    // Get markups, set container heights
    $(".code-t2 .exmctn").each(function () {
      // Find not set
      if (!$(this).hasClass("isset")) {
        // Already visible?
        let exmvis = $(this).css("display");

        // Show container
        $(this).show();

        // Get objects
        let objhe = $(this).find('.example');
        let objhc = $(this).find('.codemarkup');

        // Already visible?
        let objhevis = $(objhe).css('display');
        let objhcvis = $(objhc).css('display');

        // Set visible
        $(objhe).show();
        $(objhc).show();

        // Hide containers again
        if (exmvis == 'none') { $(this).hide(); }
        if (objhevis == 'none') { $(objhe).hide(); }
        if (objhcvis == 'none') { $(objhc).hide(); }

        // Add
        $(this).addClass("isset");
      }
    });
  },
  htmlencode: function (str) {
    // Replace and return
    return str
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/'/g, "&#39;")
      .replace(/"/g, "&#34;")
      .replace(/\//, "&#x2F;");
  },
};

// Attach
document.addEventListener("DOMContentLoaded", () => {
  frameexh.initialize();
});
